import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Col, Row } from "reactstrap";

const ActionModule = ({
	modules,
	actions,
	actionItems,
	changeCheckSelected,
	updateActions,
}) => {
	const [selectedActions, setSelectedActions] = useState([]);

	useEffect(() => {
		if (actionItems) {
			const actId = actionItems.map((action) => action.action.id) || [];
			setSelectedActions(actId);
		}
	}, [actionItems]);

	function changeCheckSelected(id) {
		let newValues = [];
		if (selectedActions.includes(id)) {
			newValues = selectedActions.filter((e) => e !== id);
		} else {
			newValues = [...selectedActions, id];
		}
		setSelectedActions(newValues);
		updateActions(newValues);
	}

	return (
		<Row>
			{actions &&
				modules &&
				modules?.map((module, id) => {
					return (
						<Col md="2" className="p-1 m-3" key={module.id}>
							<div key={module.id}>
								<h4 className="mb-2 text-decoration-underline">
									{module.name}
								</h4>
							</div>

							{actions &&
								actions.map((action, id) => {
									return (
										<div key={action.id}>
											{action.module_id == module.id && (
												<div
													className="mt-1 form-check form-switch"
													onClick={() => {
														changeCheckSelected(
															action.id,
														);
													}}
												>
													<input
														type="checkbox"
														className="form-check-input checkbox"
														checked={selectedActions.includes(
															action.id,
														)}
														onChange={() => {}}
													/>
													<label
														className="form-check-label"
														htmlFor="checkbox_1"
													>
														{action.name}
													</label>
												</div>
											)}
										</div>
									);
								})}
						</Col>
					);
				})}
		</Row>
	);
};

ActionModule.propTypes = {
	changeCheckSelected: PropTypes.func,
};

export default ActionModule;
